import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const ProductCardSkeleton = () => {
  return (
    <Card className="overflow-hidden bg-muted/30 animate-pulse">
      <CardHeader className="p-0">
        <div className="w-full aspect-video bg-gradient-to-br from-muted/50 to-muted/80" />
      </CardHeader>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center gap-2">
          <div className="h-5 w-16 bg-muted/60 rounded" />
          <div className="h-5 w-16 bg-muted/60 rounded" />
        </div>
        <div className="h-6 w-3/4 bg-muted/60 rounded" />
        <div className="space-y-2">
          <div className="h-4 w-full bg-muted/50 rounded" />
          <div className="h-4 w-5/6 bg-muted/50 rounded" />
        </div>
      </CardContent>
      <CardFooter className="p-4 pt-0 flex items-center justify-between">
        <div className="space-y-1">
          <div className="h-8 w-24 bg-muted/60 rounded" />
          <div className="h-3 w-16 bg-muted/50 rounded" />
        </div>
        <div className="h-10 w-24 bg-muted/60 rounded" />
      </CardFooter>
    </Card>
  );
};
